import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import './UserInformation.css';
import Info from '../Info/Info.js';
import Password from '../Password/Password.js';
import { PencilIcon } from '../../../../common/icons';
import ChangePasswordModal from './ChangePasswordModal';

@inject('translationsStore', 'authStore')
@observer
export default class UserInformation extends Component {
  constructor(props) {
    super(props);
    this.ChangePasswordModalRef = React.createRef();
    this.state = { visible: false };
  }

  showChangePassword = () => {
    this.setState({
      visible: !this.state.visible
    });
  };

  render() {
    const { authStore, translationsStore } = this.props;
    return (
      <div className="UserInformation" style={this.props.style}>
        <div className="header">
          <div className="title">{translationsStore.translate('profile.userInformation.title')}</div>
          <div className="changePassword">
            <PencilIcon
              className="pencilIcon"
              onClick={() => {
                this.showChangePassword();
              }}
            />
            <div
              onClick={() => {
                this.showChangePassword();
              }}
            >
              {translationsStore.translate('profile.userInformation.changePassword')}
            </div>
            <ChangePasswordModal
              visible={this.state.visible}
              onCancel={() => {
                this.setState({ visible: false });
              }}
            />
          </div>
        </div>
        <div className="fields">
          <Info label={translationsStore.translate('profile.userInformation.username')} value={authStore.user && authStore.user.username} />
          <div className="divider" />
          <Password label={translationsStore.translate('profile.userInformation.password')} value={authStore.user && authStore.user.password} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Profile/UserInformation/UserInformation.js